<template>
  <div class="showTheLogin">
    <div class="loginCent">
      <nav>
        <div class="hiddenLoginBtn">
          <a class="el-icon-close" @click="hiddenLoginBtn" />
        </div>
      </nav>
      <div class="loginForm">
        <div class="loginTitle">
          <div class="title"  v-if="isRegistered === '1'">免费注册</div>
          <div class="title"  v-if="isRegistered === '2'">邮箱登录</div>
          <div class="title"  v-if="isRegistered === '3'">忘记密码</div>
          <div class="content">
            <u @click="registered" v-if="isRegistered === '1' || isRegistered === '3'">邮箱登录</u>
            <u @click="registered" v-if="isRegistered === '2'">免费注册</u>
          </div>
        </div>
        <div class="loginFormBox">
          <div class="inputBox">
            <el-input v-model="userName" placeholder="请输入您的邮箱">
              <template slot="prepend"><span class="el-icon-platform-eleme"></span></template>
            </el-input>
          </div>
          <div class="inputBox" v-if="isRegistered === '1' || isRegistered === '3'">
            <el-input
              v-model="verificationCode"
              placeholder="请输入验证码"
              @keyup.enter.native="login"
            >
              <template slot="prepend">
                <span class="el-icon-tickets"></span>
              </template>
            </el-input>
            <span v-show="codeShow" class="codeBtn" @click="getCode">获取验证码</span>
            <span v-show="!codeShow" class="codeBtn codeCount">重新获取({{codeCountNum}}s)</span>
          </div>
          <div class="inputBox">
            <el-input v-model="password" type="password" placeholder="请输入您的密码">
              <template slot="prepend"><span class="el-icon-s-check"></span></template>
            </el-input>
          </div>
          <div class="inputBox" v-if="isRegistered === '1'">
            <el-input v-model="phone" placeholder="请输入您的手机号">
              <template slot="prepend"><span class="el-icon-phone-outline"></span></template>
            </el-input>
          </div>
          <div class="forgetPwd"  v-if="isRegistered === '2'" >
            <u @click="goForgetPwd">忘记密码</u>
          </div>
          <el-button class="loginBtn"
            @click="registerByEmail"
            v-if="isRegistered === '1'"
            :loading="loadingLogin"
          >注册</el-button>
          <el-button class="loginBtn"
            @click="login"
            v-if="isRegistered === '2'"
            :loading="loadingLogin"
          >登录</el-button>
          <el-button class="loginBtn"
            @click="forgetPassword"
            v-if="isRegistered === '3'"
            :loading="loadingLogin"
          >找回密码</el-button>
        </div>
        <div class="loginProtocol" v-if="isRegistered === '1'">
          <el-checkbox v-model="haveRead"></el-checkbox>
          <span>注册/登录即表示已同意</span>
          <span @click="readAgreement">《服务协议》</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="服务协议"
      :visible.sync="dialogAgreement"
      :append-to-body='true'
      width="50%">
    <div>江城百臻用户服务协议</div>
      <div>发布日期：2023年08月01日</div>
      <div>生效日期：2023年08月10日</div>
      <div>欢迎您注册江城百臻账号！</div>
      <div>为使用江城百臻服务，您应当阅读并遵守《江城百臻用户服务协议》（以下简称“本协议”）。请您在进一步操作之前仔细阅读、充分理解本协议的各个条款，特别是以加粗形式提示您注意的条款。如您对协议有任何疑问，可向江城百臻客服咨询。您有权选择同意或不同意本协议，您点击勾选“同意”即视为您已阅读并接受本协议的所有条款。</div>
      <div>您完成注册程序或使用第三方账号登录江城百臻，使用江城百臻服务，即视为您已充分阅读、理解本协议，并自愿受本协议的约束。阅读本协议过程中，如果您不同意本协议或其中任何条款，请立即停止注册程序并停止使用江城百臻服务。</div>
      <div>一、定义</div>
      <div>1、江城百臻指维萨银海（上海）技术有限公司及其关联公司经营的电商平台，包括但不限于江城百臻APP、微信小程序、百度小程序、PC站、手机网站等，作为电子商务平台经营者，江城百臻仅为第三方入驻商家（以下简称“商家”或“销售方”）与您达成交易提供网页空间、虚拟经营场所、交易规则等服务，江城百臻并非商家与您之间交易行为的参与方。</div>
      <div>2、用户服务协议：即本协议，指您与江城百臻订立的旨在约定您登录、使用江城百臻以及通过江城百臻下达订单、购买商品、支付货款、收取商品等整个网购过程中，您与江城百臻之间的权利、义务的书面合同。</div>
      <div>二、协议范围及变更</div>
      <div>1、[协议范围]本协议内容包括协议正文及所有江城百臻发布的各类规则、规范、规则解读、实施细则、通知、公告等（详见江城百臻规则中心所公布的各项规则）。所有规则为本协议不可分割的一部分，与协议正文具有同等法律效力。</div>
      <div>2、[协议变更]根据国家法律法规变化、运营需要或为提升服务质量的目的，江城百臻将在必要的时候对各类规则进行修改更新，并通过在网页或移动客户端上发出公告、站内信等合理、醒目的方式向您进行提前通知，上述修改更新内容将在相关更新说明中指定的日期开始实施，通常情况下不短于发布之日后七个自然日。修订后的协议一经实施，将完全替代修订前的协议。您应当及时查阅并了解相关更新修改内容，如您不同意相关更新修改内容，可停止使用相关更新修改内容所涉及的服务，此情形下，变更事项对您不产生效力；如您在上述更新修改内容实施后继续使用所涉及的服务，将视为您已同意各项更新修改内容。</div>
      <div>三、用户账户</div>
      <div>1、[用户资格]使用江城百臻服务的用户必须是中华人民共和国法律规定的具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。</div>
      <div>2、[账户注册]注册江城百臻用户账户时，您应当提供真实、有效的信息（包括但不限于姓名、电子邮箱、联系电话、联系地址等）；同时，您应当保证上述信息的持续有效性，一旦信息发生变化，您应当及时进行更新；否则您应当承担因信息提供不真实、联系方式无效或涉嫌侵犯他人合法权益导致的相关不利后果及全部损失，且江城百臻保留终止向您提供服务的权利。</div>
      <div>3、[账户安全]您的账户由您自行设置并保管，江城百臻任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时,退出登录并以正确步骤离开江城百臻。您应对您的账号和密码或您确认的手机号码或短信验证码的安全，以及对通过您的账户和密码或您确认的手机号码及短信验证码实施的行为负责。如发现未经授权使用您的账户或有任何其他可能危及到您的账户安全的情形时，您应当立即以有效方式通知江城百臻，要求暂停相关服务。您理解江城百臻对您的任何请求采取行动均需要合理时间，除江城百臻存在过错或法律明确规定外，江城百臻对在采取行动前已经产生的后果（包括但不限于用户账户遗失、数据泄露或其他损害）不承担责任。如因您主动泄露、出借账户信息或因您遭受他人攻击、诈骗等行为导致的损失及后果，江城百臻可协助您采取冻结或关闭账户、停止提供服务等措施，您应通过司法、行政等救济途径向侵权行为人追偿。</div>
      <div>四、商品或服务规范</div>
      <div>1、[订单信息]当您在江城百臻购买商品或服务时，请您务必仔细确认所购商品的名称、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。</div>
      <div>2、[订单生效]您通过江城百臻下达订单后，仅表示系统接收到了您下达的订单，不代表您与商家之间的订单已经成立生效。只有您与商家协商达成一致，并支付价款后，您与商家之间的订单方才成立生效。</div>
      <div>3、[交易秩序]您的购买行为应当基于真实的消费需求，不得实施恶意购买、恶意维权等扰乱江城百臻正常交易秩序的行为。基于维护江城百臻交易秩序及交易安全的需要，江城百臻发现上述情形时有权采取关闭相关交易订单等措施。</div>
      <div>4、[评价规范]您有权在江城百臻提供的评价系统中对您购买的商品或服务进行评价。您的所有评价行为应遵守法律法规及/或江城百臻规则的相关规定，评价内容应当客观真实，不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不得以不正当方式帮助他人提升好评率或利用评价权利对其他用户实施威胁、敲诈勒索。江城百臻可按照法律法规及/或江城百臻规则的相关规定对您发布的违规信息进行屏蔽等，并有权视情形对您采取身份验证、限制购买行为、封禁账户权限等处理措施。</div>
      <div>5、[商品规范]当您拥有江城百臻店铺功能后，您将自愿承诺：</div>
      <div>（1）不销售国家明令淘汰或者过期、失效、变质的商品；</div>
      <div>（2）不销售掺杂、掺假、以假充真、以次充好的商品，不得以不合格商品冒充合格商品；</div>
      <div>（3）在销售过程中不出现缺斤少两的情况；不销售三无产品，商品包装上必须注明制造商名称、生产地址、商品名称、规格、生产日期、保质期等内容，初级农副产品除外；</div>
      <div>（4）商品销售时说明是否为临期产品（“临期”指消费者收到商品时的日期已经超过保质期的2/3时间）；</div>
      <div>（5）不违反国家法律法规规定的其他相关要求。</div>
      <div>6、[交易规范]您不得从事扰乱江城百臻秩序的行为，包括但不限于：</div>
      <div>（1）通过任何不正当手段达成交易或参与活动，如使用插件、外挂等工具；</div>
      <div>（2）从事虚假交易；</div>
      <div>（3）提供虚假信息；</div>
      <div>（4）套取活动道具、套取补贴；</div>
      <div>（5）从事赌博、洗钱、违规套现、刷信誉等行为；</div>
      <div>（6）利用技术漏洞或规则漏洞下单、获取福利、补贴；</div>
      <div>（7）恶意退款；</div>
      <div>（8）超出真实的消费需求购买商品；</div>
      <div>（9）从事其他扰乱综合平台交易及管理秩序的行为。</div>
      <div>7、[权益保护]您不得从事有损于江城百臻或任何第三方合法权益的行为，包括但不限于：</div>
      <div>（1）假冒江城百臻或商家发布任何诈骗或虚假信息；</div>
      <div>（2）利用江城百臻传播恶意程序或计算机病毒；</div>
      <div>（3）下单后无正当理由拒不收货、提货；</div>
      <div>（4）恶意对江城百臻的商品进行负面评价；</div>
      <div>（5）发布违规信息、垃圾信息的；</div>
      <div>（6）恶意索赔、投诉的；</div>
      <div>（7）协助他人获取不正当利益，或教唆他人从事本协议所禁止的行为；</div>
      <div>（8）从事其他有损于江城百臻或任何第三方合法权益的行为。</div>
      <div>8、[投诉处理]如您被平台用户投诉，涉及到违法或违反本协议的行为，平台将第一时间告知您，您必须于3个工作日内提交举证资料，如未提供平台有权公布您的违法行为及部分用户信息并做出处罚（包括但不限于限权、商品下架、用户违法信息曝光、终止服务等）。</div>
      <div>9、[责任承担]除另有明确说明外，江城百臻平台上销售的商品/服务的相关信息由商家自行制作、上传，江城百臻尽可能通过本协议或发布平台规则等方式约束商家提供准确、完整、可靠、有效、没有错误和误导性的商品描述。对于因商品信息导致的纠纷，江城百臻基于平台管理和保护消费者利益的需要，将依据相关法律法规、江城百臻与相应平台商家之间的约定及/或平台规则，督促商家履行其对您作出的承诺或赔付责任。</div>
      <div>10、[处理提示]江城百臻有权受理并调解您与其他用户因交易或利益产生的争议，同时有权单方面独立判断其他会员对您的投诉及(或)索偿是否成立，若江城百臻判断投诉（或）索偿成立，有权终止您在江城百臻的一切账号和关联服务，江城百臻有权通过第三方支付公司扣减您账户的相应款项（包括但不限于保证金、返佣、货款），同时江城百臻保留追究法律责任的权利。</div>
      <div>11、[纠纷调处]平台用户在交易履行过程中产生争议，双方自行协商解决；若双方无法协商或协商不能达成一致意见，一方或双方可申请提交江城百臻进行斡旋处理。您理解并同意，在争议调解中，江城百臻客服并非专业人士，仅能以普通或非专业人员的知识水平标准对用户提交的凭证进行判断，江城百臻无法保证争议调处结果符合您和/或平台用户的期望，也不对交易纠纷调处结果及赔付决定承担责任。</div>
      <div>五、费用</div>
      <div>1、费用</div>
      <div>江城百臻向您提供的服务付出了成本，除江城百臻明示的收费业务外，向您提供的服务目前是免费的。若未来江城百臻向您收取合理费用，江城百臻采取合理的途径并提前通过法定程序以本协议约定的有效方式通知您，确保您有足分选择的权利。</div>
      <div>2、应纳税赋</div>
      <div>依法纳税是每个公民、企业应尽的义务，您应对销售额/营业额超过法定免征额部分及时、足额地向税务主管机关申报纳税。</div>
      <div>3、结算和提现</div>
      <div>当您在江城百臻交易时，视为自愿接受由江城百臻提供的各类支付技术服务，入驻江城百臻的商家自发布供应之日起即视为承诺遵守江城百臻的有关规定并同意收取交易通道手续费（具体标准详见《结算及提现说明》）。</div>
      <div>六、知识产权</div>
      <div>1、[平台知产]江城百臻提供的服务中包含的任何编码、商标、服务标志、图形、美术品、照片、肖像、文字内容、音频、视频、按钮图标以及计算机软件、标识、数码下载、数据汇编等都是江城百臻或其内容提供者的财产，受到中华人民共和国版权、商标权和其他财产所有权法律法规的保护。</div>
      <div>2、[用户授权]对于您在任何时间以任何形式向江城百臻提供或在江城百臻发表的信息或资料（包括但不限于文字、图片、视频、音频等）相关的知识产权，您同意免费授予江城百臻及其关联公司获得全球排他的许可使用权利及再授权给其他第三方使用的权利。</div>
      <div>3、[侵权责任]您同意，因您通过江城百臻上传、发布的任何内容导致的知识产权侵权问题，您将承担全部责任；如江城百臻及其关联公司，或江城百臻授权的其他服务提供方因第三方知识产权维权而产生损失，您将等额赔偿。</div>
      <div>七、用户行为规范</div>
      <div>1、禁止行为</div>
      <div>您不得进行任何侵犯江城百臻知识产权的行为，或者进行其他有损于江城百臻或其他用户合法权益的行为，包括但不限于：</div>
      <div>（1）删除或修改江城百臻平台上的版权信息；</div>
      <div>（2）对江城百臻及其中的相关信息擅自出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点，借助江城百臻发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；</div>
      <div>（3）在江城百臻中内置各种插件程序或者其他的第三方程序，或者制作、发布、传播上述程序，而无论是否出于商业目的；</div>
      <div>（4）进行编译、反编译、反向工程或者以其他方式破解江城百臻的行为；</div>
      <div>（5）使用江城百臻外挂和/或利用江城百臻当中的 BUG 来获得不正当的利益；</div>
      <div>（6）利用劫持域名服务器等技术非法侵入、破坏江城百臻的服务器软件系统，或者修改、增加、删除、窃取、截留、替换江城百臻的客户端和/或服务器软件系统中的数据，或者非法挤占江城百臻的服务器空间，或者实施其他的使之超负荷运行的行为；</div>
      <div>（7）假冒江城百臻或商家在江城百臻当中发布任何诈骗或虚假信息；</div>
      <div>（8）利用江城百臻平台故意传播恶意程序或计算机病毒。</div>
      <div>2、信息发布</div>
      <div>您应当遵守国家有关法律法规，不得在江城百臻当中发表、转发或者传播含有下列内容的信息：</div>
      <div>（1）反对宪法所确定的基本原则的；</div>
      <div>（2）危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的；</div>
      <div>（3）损害国家荣誉和利益的；</div>
      <div>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</div>
      <div>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
      <div>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
      <div>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
      <div>（8）侮辱或者诽谤他人，侵害他人合法权益的；</div>
      <div>（9）含有法律、行政法规禁止的其他内容的。</div>
      <div>3、违反规则的后果</div>
      <div>(1)如您使用江城百臻平台时存在违反国家法律法规、本协议、侵害他人利益、江城百臻利益或社会公共利益、严重违背社会公德等情形，江城百臻有权采取屏蔽相关信息、封禁账户权限、中止或终止提供服务等处理措施。</div>
      <div>(2)在不限制其他补救措施的前提下，发生下述任一情况，江城百臻立即发出警告，采取暂时中止、永久中止或终止您的帐号使用资格，删除您在平台上的产品信息及您在网站上展示的任何其他资料：</div>
      <div>(i)您违反本协议；</div>
      <div>(ii)无法核实或鉴定您向江城百臻提供的任何资料；</div>
      <div>(iii)您从事涉嫌诈骗活动，平台随时终止您的账户。</div>
      <div>4、法律责任</div>
      <div>（1）您需要对您在江城百臻的言论及行为承担法律责任，若您违反国家法律法规的规定，江城百臻的系统记录有可能成为您违反法律法规的证据。</div>
      <div>（2）因您违反本协议或江城百臻规则而产生的第三方索赔请求，由您自行承担法律责任；由此导致江城百臻遭受损失的，您应当一并赔偿。</div>
      <div>八、有限责任</div>
      <div>1、[责任限制]不论在何种情况下，江城百臻均不对由于互联网连接故障，电脑、通讯或其他系统的故障，电力故障，计算机病毒，程序漏洞，罢工，暴乱，起义，骚乱，火灾，洪水，风暴，爆炸，战争，政府行为，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。</div>
      <div>2、[其他免责]江城百臻依照法律规定履行基础保障义务，您理解并同意，江城百臻需要定期或者不定期地对江城百臻设备进行维护或者检修，因此造成的江城百臻服务在合理时间内的中断，江城百臻将事先通知您。</div>
      <div>九、个人信息保护</div>
      <div>江城百臻重视您的个人信息保护，在您使用江城百臻提供的服务时，您同意江城百臻按照本协议及《江城百臻隐私政策》的规定收集、存储、使用、披露和保护您的个人信息。如您使用江城百臻用户账户登录江城百臻相关产品或服务，但该产品或服务未设置独立隐私政策的，为保护您的隐私，我们将适用《江城百臻隐私政策》对您的个人信息进行收集、存储、使用、披露和保护。</div>
      <div>十、期限、解除与终止</div>
      <div>1、[协议期限]本协议自您确认同意之日起生效并长期有效。</div>
      <div>2、[协议终止]出现以下情况时，江城百臻可以以本协议约定的方式通知您，并终止本协议：</div>
      <div>（1）您违反本协议约定，江城百臻依据违约条款终止本协议的；</div>
      <div>（2）您盗用他人账户、发布违禁信息、骗取他人财物、扰乱市场秩序、采取不正当手段谋利等行为，江城百臻依据江城百臻规则对您的账户予以查封的；</div>
      <div>（3）除上述情形外，因您多次违反江城百臻规则相关规定且情节严重，江城百臻依据江城百臻规则对您的账户予以查封的；</div>
      <div>（4）您的账户被江城百臻回收的；</div>
      <div>（5）其它应当终止服务的情况。</div>
      <div>3、[账户注销]您可以按照江城百臻平台公示的方式或者联系江城百臻平台客服要求注销账户，终止本协议。注销账户的条件在江城百臻平台公示或询问江城百臻平台客服。您知晓并理解以下情况：</div>
      <div>（1）您注销账户时需所有交易需为完成状态，账户资金为零，否则将暂时不予注销。</div>
      <div>（2）如果账号存在纠纷或者安全隐患，将暂时不予注销。</div>
      <div>（3）注销账户后，您将放弃账户信息以及该账户在江城百臻的资产、虚拟权益（包括但不限于优惠券、粮票、会员权益、店铺等级等），且江城百臻无法为您恢复前述服务，并对您主张售后服务带来不便。</div>
      <div>（4）您注销账户后，您的个人信息在江城百臻前台将不可检索、访问。您知晓并理解，相关交易记录须在法律规定的期限内予以保存。</div>
      <div>4、[后续事项]协议终止或解除后续事项的处理：</div>
      <div>（1）自本协议终止或解除之日起，江城百臻将关闭您在江城百臻平台的账户权限。</div>
      <div>（2）本协议终止或解除后，江城百臻有权保留您的注册信息及交易行为记录等数据，但江城百臻不承担在协议终止后向您或第三方提供任何数据信息的义务，也不就协议终止向您或任何第三方承担责任，但法律法规另有规定的除外。</div>
      <div>（3）本协议终止或解除后，江城百臻仍保留对您过往的违约行为追究责任的权利。</div>
      <div>十一、法律适用与管辖</div>
      <div>1、本协议的内容、解释或其执行所产生的任何争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。</div>
      <div>2、您因使用江城百臻服务所产生及与江城百臻服务有关的争议，由江城百臻与您协商解决。协商不成时，任何一方均可向被告住所地或合同履行地人民法院提起诉讼。</div>
      <div>十二、通知</div>
      <div>1、您在注册江城百臻账户时所填写的联系电话、电子邮箱地址、联系地址视为您的有效通知地址。若上述信息发生变更您应当及时进行更新，如果因您提供的联系方式不准确，或不及时告知变更后的联系方式，使相关通知（包括但不限于协议变更、法律文书等）无法送达或未及时送达，由您自行承担可能产生的法律后果。</div>
      <div>2、江城百臻通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在江城百臻公告，向您提供的联系电话发送手机短信，向您提供的电子邮箱发送电子邮件，向您的江城百臻用户账户发送系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</div>
      <div>3、对于与江城百臻有关的任何纠纷，您同意行政、公安、司法等有权机关可以通过手机短信、电子邮件、系统消息或站内信等方式向您送达法律文书，有权机关向上述联系方式发出法律文书即视为送达；若同时采取以上多种方式向您送达法律文书，送达时间以最先送达的为准。您同意上述送达方式适用于行政、仲裁、司法等法定程序全过程。</div>
      <div>十三、其他</div>
      <div>1、若本协议任何条款被裁定为无效或不可强制执行，该项条款应被撤销，而其余条款应予遵守和执行。</div>
      <div>2、条款标题仅为方便参阅，并不以任何方式界定、限制、解释或描述本协议条款的范围或限度。</div>
      <div>3、江城百臻未就您或其他人士的某项违约行为采取行动，并不表明江城百臻撤回就任何继后或类似的违约事件采取行动的权利。</div>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import store from '@/store/index.js'
import {
  // getTheCode,
  login,
  getEmailCode,
  registerByEmail,
  forgetPassword
} from '@/api/login.js'
import {
  getUserInfo
} from '@/api/user/user.js'
export default {
  name: 'login',
  data () {
    return {
      userName: '',
      password: '',
      phone: '',
      verificationCode: '',
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: '',
      dialogAgreement: false,
      isRegistered: '2', // 1-注册；2-登录；3-找回密码
      loadingLogin: false
    }
  },
  mounted () {
    this.isRegistered = store.state.isRegistered
  },
  methods: {
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        store.commit('SET_USERINFO', res.data)
        this.userInfoData = res.data
      }
    },
    async getCode () {
      const TIME_COUNT = 60
      // let reg = /^1[13456789]\d{9}$/
      let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!reg.test(this.userName)) {
        this.$message({
          // message: '手机号格式错误',
          message: '邮箱格式错误',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      // const response = await getTheCode({ phone: this.userName })
      const response = await getEmailCode({ email: this.userName })
      const res = response.data
      if (res.code === '200') {
        if (!this.timer) {
          this.codeCountNum = TIME_COUNT
          this.codeShow = false
          this.timer = setInterval(() => {
            if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
              this.codeCountNum--
            } else {
              this.codeShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        this.$message({
          message: '验证码获取成功',
          type: 'success',
          customClass: 'messageZindex'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },
    // 阅读协议
    readAgreement () {
      this.dialogAgreement = true
    },
    // 邮箱注册
    async registerByEmail () {
      if (this.userName === '' || this.verificationCode === '' || this.phone === '' || this.password === '') {
        this.$message({
          message: '请检查注册信息是否填写完整',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }

      // 必须包含大小写字母、数字、特殊字符长度再8-16位之间
      const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!,.?@#$%^&*])[\da-zA-Z~!,.?@#$%^&*]{8,}$/
      if (this.password.length < 8 || this.password.length > 16) {
        this.$message({
          message: '请输入8~16位密码',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      if (!regex.test(this.password)) {
        this.$message({
          message: '密码必须包含大小写字母、数字、特殊字符长度再8-16位之间',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }

      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(this.phone)) {
        this.$message({
          message: '手机号格式错误',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      this.loadingLogin = true
      const response = await registerByEmail({
        email: this.userName,
        emailVerificationCode: this.verificationCode,
        password: this.password,
        phone: this.phone
      })
      const res = response.data
      if (res.code === '200') {
        this.getUserInfoData()
        this.$message({
          message: '注册成功，请登录',
          type: 'success',
          customClass: 'messageZindex'
        })
        // location.reload()
        this.$router.push({path: '/index'})
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
      this.loadingLogin = false
    },
    login () {
      // let reg = /^1[13456789]\d{9}$/
      // if (!reg.test(this.userName)) {
      //   this.$message({
      //     message: '手机号码格式错误',
      //     type: 'error',
      //     customClass: 'messageZindex'
      //   })
      //   return
      // }
      // if (this.verificationCode === '') {
      //   this.$message({
      //     message: '请输入验证码',
      //     type: 'warning',
      //     customClass: 'messageZindex'
      //   })
      //   return
      // }
      if (this.userName === '' || this.password === '') {
        this.$message({
          message: '请检查登录信息是否填写完整',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      if (this.isRegistered === '2') {
        this.getLogin()
      } else if (this.haveRead) {
        this.getLogin()
      } else {
        this.$message({
          message: '请阅读并同意服务协议',
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },
    async getLogin () {
      this.loadingLogin = true
      const response = await login({
        email: this.userName,
        password: this.password,
        // verificationCode: this.verificationCode,
        type: this.isRegistered,
        terminal: 5
      })
      const res = response.data
      if (res.code === '200') {
        if (this.isNoLogin) {
          Cookie.set('token', res.data.token, { expires: 7 })
        } else {
          Cookie.set('token', res.data.token, { expires: 1 })
        }
        this.getUserInfoData()
        this.$message({
          message: '登录成功',
          type: 'success',
          customClass: 'messageZindex'
        })
        store.commit('SHOW_LOGIN')
        store.commit('IS_LOGIN', true)
        location.reload()
        // this.$router.push({path: '/index'})
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
      this.loadingLogin = false
    },
    registered () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
      this.userName = ''
      this.verificationCode = ''
      if (this.isRegistered === '1' || this.isRegistered === '3') {
        this.isRegistered = '2'
      } else {
        this.isRegistered = '1'
      }
    },
    goForgetPwd () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
      this.userName = ''
      this.verificationCode = ''
      this.isRegistered = '3'
    },
    //  忘记密码-邮箱验证
    async forgetPassword () {
      if (this.userName === '' || this.verificationCode === '' || this.password === '') {
        this.$message({
          message: '请检查信息是否填写完整',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }

      // 必须包含大小写字母、数字、特殊字符长度再8-16位之间
      const regex = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!,.?@#$%^&*])[\da-zA-Z~!,.?@#$%^&*]{8,}$/
      if (this.password.length < 8 || this.password.length > 16) {
        this.$message({
          message: '请输入8~16位密码',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      if (!regex.test(this.password)) {
        this.$message({
          message: '密码必须包含大小写字母、数字、特殊字符长度再8-16位之间',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      this.loadingLogin = true
      const response = await forgetPassword({
        email: this.userName,
        emailVerificationCode: this.verificationCode,
        password: this.password
      })
      const res = response.data
      if (res.code === '200') {
        this.getUserInfoData()
        this.$message({
          message: '密码找回成功，请登录',
          type: 'success',
          customClass: 'messageZindex'
        })
        // location.reload()
        this.$router.push({path: '/index'})
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
      this.loadingLogin = false
    },
    // 关闭登录
    hiddenLoginBtn () {
      store.commit('SHOW_LOGIN')
    }
  }
}
</script>

<style lang="scss" scoped>
.showTheLogin {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .loginCent {
    width: 360px;
    min-height: 320px;
    padding: 20px 60px;
    margin-right: 36%;
    margin-top: 10%;
    float: right;
    background-color: #ffffff;
    nav{
      margin-bottom: 40px;
      .hiddenLoginBtn{
        a{
          float: right;
        }
      }
    }
    .loginForm {
      width: 100%;
      height: 100%;
      background: #ffffff;
      .loginTitle{
        display: flex;
        justify-content: space-between;
        font-family: Microsoft YaHei;
        color: #4dc832;
        font-weight: 800;
        .title{
          font-size: 20px;
        }
        .content{
          margin: 10px 0;
          font-size: 14px;
          u{
            color: #999999;
            cursor: pointer;
          }
        }
      }
      .loginFormBox {
        .inputBox {
          position: relative;
          .el-input{
            .iconfont{
              font-size: 20px;
              padding: 0 1px;
            }
          }
          >>> .el-input__inner {
            height: 40px;
            background: #fff;
            border-radius: 0px;
            font-size: 14px;
            padding-left: 5px;
          }
          &:nth-child(2) {
            margin: 20px 0 10px 0;
          }
          &:nth-child(3) {
            margin: 20px 0 10px 0;
          }
          &:nth-child(4) {
            margin: 20px 0 10px 0;
          }
          .codeBtn {
            width: 80px;
            height: 35px;
            background: #fff;
            color:#4dc832;
            border-radius: 0;
            display: block;
            line-height: 35px;
            text-align: center;
            position: absolute;
            right: 1px;
            bottom: 1px;
            cursor: pointer;
            font-size: 12px;
          }
          .codeCount {
            color: #999999;
          }
        }
        .forgetPwd{
          color: #999999;
          margin: 10px 0;
          font-size: 14px;
          u{
            color: #999999;
            cursor: pointer;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          // margin:20px 0 60px 0;
          height: 30px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            text-decoration: underline;
            color: #666666;
          }
        }
        .registered {
          justify-content: flex-end;
        }
        .loginBtn {
          width: 87%;
          // height: 20px;
          background: #4dc832;
          border-radius: 4;
          border: 1px solid #E5E5E5;
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          cursor: pointer;
          &:hover{
            border: 1px solid $mainGlod;
          }
          color: #fff;
        }
      }
      .loginProtocol {
        padding: 0 30px;
        display: flex;
        align-items: center;
        // height: 80px;
        // line-height: 80px;
        border-top: 1px solid #EEEEEE;
        span {
          margin-top: 20px;
          margin-left: 10px;
          color:#666666;
          font-size: 12px;
        }
        span:nth-child(3) {
          color: #4dc832;
          cursor: pointer;
          font-size: 12px;
        }
      }
      >>> .el-checkbox__inner {
        margin-top: 20px;
        width: 20px;
        height: 20px;
        border-color: #4dc832;
        // background-color: #4dc832;
        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }
  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}
.hiddenLogin {
  display: none;
}
@keyframes showRight {
  from {
    width: 560px;
    opacity: 0;
  }
  to {
    width: 220px;
    opacity: 1;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue